// extracted by mini-css-extract-plugin
export default {"program-description":"ProgramDescription_program-description__KIbX8"};